// reducers/password/index.js

import { combineReducers } from 'redux';
import { token }           from './token';
import { tokenHasErrored } from './token';
import { tokenIsLoading }  from './token';

const tokenReducers = combineReducers({
  token,
  tokenHasErrored,
  tokenIsLoading
});

export default combineReducers({
  token: tokenReducers
});